var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconETravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 28,
    viewBox: "0 0 39 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#FFAE00",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1160.205 2346.228c.903-.398 1.92-.257 2.743.283l.942.922c.128.186.242.387.337.603.73 1.656.111 3.531-1.38 4.188l-9.014 3.972-6.208 15.324s-.2.796-1.221 1.246l-2.8 1.234 2.016-14.184-9.49 4.182c-1.155.508-2.493.139-3.378-.821l-.025-.027-.003-.003-6.724-7.315 2.977-1.312c.654-.288 1.09-.097 1.09-.097l4.433 3.132zm-22.93 1.41c.653-.288 1.09-.098 1.09-.098l8.965 3.614-6.316 2.783-6.716-4.988 2.977-1.311z",
    transform: "translate(-1126 -2346)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconETravel);
export default __webpack_public_path__ + "static/media/icon-e-travel.289d0c629f9ac8bf7178abe2d19a3476.svg";
export { ForwardRef as ReactComponent };